export const PUBLIC_PAGES = [
    "training-survey"
];

/**
 * Method that checks if the current browser page is public to hide header and footer
 *
 * @param {string} href Current browser url.
 * @return {boolean} Flag that indicates if the page is public.
 */
export const checkPublicPage = (href) => {
    let publicPage = false;

    for (let i = 0; i < PUBLIC_PAGES.length; i++) {
        if(href.includes(PUBLIC_PAGES)) {
            publicPage = true;
            break;
        }
    }

    return publicPage;
}